<!-- <p>fluad-third works!</p> -->
<div class="breadcrumbs--page-nav hidden-xs hidden-sm fluad-breadcrumbs">
    <div class="container">
        <p><a [routerLink]="'/'">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><a [routerLink]="'/products'">{{"statictext.products" | cxTranslate}}</a><span> &gt;
            </span><strong>{{"statictext.fluadtxt" | cxTranslate}}</strong></p>
    </div>
</div>
@if (challengesbanner | async; as item) {
  <div class="product_image-textCenter fluad_image-center">
    <div class="simple-banner banner__component--responsive">
        <!-- <img class="js-responsive-image Desktop_Old_Woman_Image"
            alt="A mature woman and man, side-by-side facing the same direction, gazing into the distance"
            title="A mature woman and man, side-by-side facing the same direction, gazing into the distance"
          [src]="getImage(item.media)"> -->

          <!-- The following is for upto minimum 400px-->
          <img class="js-responsive-image Mobile_Old_Woman_Image"
          alt="A mature woman and man, side-by-side facing the same direction, gazing into the distance"
          title="A mature woman and man, side-by-side facing the same direction, gazing into the distance"
        [src]="getMobileImage(item.media)">
        <cx-media [alt]="item?.altText" [container]="item?.media" class="resposnive_Old_Woman_Image"></cx-media>
      </div>
      <div class="product_image-textinside hidden-md hidden-lg" [innerHTML]="item?.urlLink"></div>
      <div class="container">
        <div class="product_image-textcontainer">
            <div class="product_image-textHeader">

                <!--for mobile-->
                <div class="hidden-md hidden-lg mobile_Image_TextHeader1 d-none" [innerHTML]="item.name"></div>
                <div class="product_image-subtext1 mobile_Product_Image-Subtext1 d-none" [innerHTML]="item.text1Content"></div>  
                <!--Plus symbol and desktop header 2-->           
                <div class="product_imagePlus">+</div>

                <!--for mobile-->
                <div class="hidden-md hidden-lg mobile_Product_Image-TextHeader2 d-none" [innerHTML]="item.head2Line"></div>
                <div class="product_image-subtext2 mobile_Product_Image-Subtext2 d-none" [innerHTML]="item.text2Content"></div>
            </div>
            <!--subtext for laptop-->
            <div class="product_image-text1 hidden-xs hidden-sm">
                <div class="wrapper_container_1">
                    <div class="product_image-textHeader1 hidden-xs hidden-sm"[innerHTML]="item.head1Line"></div>
                    <div class="product_image-subtext1" [innerHTML]="item.text1Content"></div>
                </div>
                <div class="product_image-subtext3"> <div class="product_imagePlus1">+</div></div>
                <div class="wrapper_container_1">
                    <div class="product_image-textHeader2 hidden-xs hidden-sm" [innerHTML]="item.head2Line"></div>
                    <div class="product_image-subtext2" [innerHTML]="item.text2Content"></div>
                </div>
            </div>
        </div>
        <div class="product_box1-disclaimer">{{item.bottomContent}}</div>
    </div>
</div>
}